class CartSubscription {
    constructor() {
        this.init();
    }

    init() {
        this.container = document.querySelector('.drawer__items');
        if (!this.container) return;

        this.observer = new MutationObserver(() => {
            this.refreshSubscriptionButtons();
        });
        this.observer.observe(this.container, { childList: true, subtree: true });

        this.refreshSubscriptionButtons();
    }

    refreshSubscriptionButtons() {
        this.cartItems = this.container.querySelectorAll('[data-cart-item]');

        this.cartItems.forEach(item => {
            const hasSubscription = item.dataset.hasSubscription === 'true';
            const currentPlanId = item.dataset.currentPlanId;
            const isSupplement = item.dataset.isSupplement === 'true';

            /*
            console.log('Cart Item Data:', {
                hasSubscription,
                currentPlanId,
                isSupplement,
                allDataset: item.dataset
            });
            */

            if (hasSubscription) {
                if (currentPlanId) {
                    this.showPlanSelector(item);
                } else {
                    this.addUpgradeButton(item);
                }
            }
        });
    }

    addUpgradeButton(item) {
        if (item.querySelector('.subscription-upgrade-button')) return;
        const plans = JSON.parse(item.dataset.subscriptionPlans || '[]');
        const discountPercentage = (plans[0]?.discount_percentage) || 5;

        const upgradeButton = document.createElement('button');
        upgradeButton.classList.add('subscription-upgrade-button', 'button', 'button--primary', 'button--small');
        upgradeButton.setAttribute('type', 'button');
        upgradeButton.setAttribute('data-subscription-button', '');

        upgradeButton.innerHTML = `
            <span class="subscription-upgrade-content">
                Upgrade to Subscription & Save
            </span>
        `;

        upgradeButton.addEventListener('click', () => this.handleUpgrade(item));

        const contentContainer = item.querySelector('.cart__item__content');
        if (contentContainer) {
            contentContainer.insertAdjacentElement('afterend', upgradeButton);
        }
    }

    async handleUpgrade(item) {
        try {
            const itemKey = item.dataset.cartItemKey;
            const plans = JSON.parse(item.dataset.subscriptionPlans || '[]');

            if (!plans || plans.length === 0) return;

            const firstPlan = plans[0];
            await this.updateCartItem(itemKey, firstPlan.id);
        } catch (error) {
            window.dispatchEvent(new CustomEvent('cart:error', {
                detail: { error }
            }));
        }
    }

    async updateCartItem(itemKey, sellingPlanId) {
        try {
            const response = await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: itemKey,
                    selling_plan: sellingPlanId || ''
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const cart = await response.json();

            await new Promise(resolve => setTimeout(resolve, 500));

            if (window.theme && window.theme.cartDrawer) {
                await window.theme.cartDrawer.refresh();
            } else {
                const cartSection = await fetch('/?section_id=cart-drawer');
                const html = await cartSection.text();
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newContent = doc.querySelector('.drawer__items')?.innerHTML || '';

                const drawerItems = document.querySelector('.drawer__items');
                if (drawerItems) {
                    drawerItems.innerHTML = newContent;
                    drawerItems.querySelectorAll('[data-animation="cart-items-fade"]').forEach(item => {
                        item.style.opacity = '1';
                        item.removeAttribute('data-animation');
                    });
                }
            }

            await new Promise(resolve => setTimeout(resolve, 100));
            new CartSubscription();

        } catch (error) {
            window.dispatchEvent(new CustomEvent('cart:error', {
                detail: { error }
            }));
        }
    }

    showPlanSelector(item) {
        if (item.querySelector('.subscription-plan-selector')) return;

        const select = document.createElement('select');
        select.classList.add('subscription-plan-selector');

        const plans = JSON.parse(item.dataset.subscriptionPlans || '[]');
        const currentPlanId = item.dataset.currentPlanId;

        plans.forEach(plan => {
            const option = document.createElement('option');
            option.value = plan.id;

            const discount = plan.price_adjustments[0]?.value || 0;
            option.textContent = `${plan.name}`;

            if (currentPlanId === plan.id.toString()) {
                option.selected = true;
            }
            select.appendChild(option);
        });

        select.addEventListener('change', async (e) => {
            const itemKey = item.dataset.cartItemKey;
            await this.updateCartItem(itemKey, e.target.value);
        });

        const contentContainer = item.querySelector('.cart__item__content');
        if (contentContainer) {
            contentContainer.insertAdjacentElement('afterend', select);
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new CartSubscription();
});

document.addEventListener('theme:cart-drawer:open', () => {
    new CartSubscription();
});